export const isElementVisible = (el) => {
	return !!el?.offsetParent
}
